import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import usedeletedata from '../../Hooks/useDeleteData';
import {
  Add_StageType,
  Delete_StageType,
  Get_All_StageType,
  Get_Error,
  Get_One_StageType,
  Update_One_StageType,
} from '../Types';

export const Add_StageType_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/stagetype`, body);

    dispatch({
      type: Add_StageType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all stagetype data
export const GetAllstagetypeData = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/stagetype?isstagetypeactivate=true`);

    dispatch({
      type: Get_All_StageType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all stagetype data not active
export const GetAllstagetypeDataNotActive = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/stagetype?isstagetypeactivate=false`);

    dispatch({
      type: Get_All_StageType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one stagetype data
export const GetOnestagetypeData = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/stagetype/${id}`);

    dispatch({
      type: Get_One_StageType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one stagetype data
export const UpdateOnestagetypeData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/stagetype/${id}`, body);

    dispatch({
      type: Update_One_StageType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one stagetype data
export const DeleteOnestagetypeData = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/stagetype/${id}`);

    dispatch({
      type: Delete_StageType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
